import { Accordion, Heading, Stack, useText } from "@sveabank/cc-common";
import { useState } from "react";
import type { ClcBeneficialOwner } from "../../../../types/clc-application";
import ClcPersonCard from "../shared/person-card";
import { DeleteBeneficialOwnerModal } from "./delete-beneficial-owner-modal";
import { BeneficialOwnershipRangeField } from "./ownership-range-field";
import { BeneficialOwnershipTypeField } from "./ownership-type-field";

type Props = {
	person: ClcBeneficialOwner;
	isApplicant?: boolean;
	isShareholder?: boolean;
	isMajorShareholder: boolean;
	onDelete: () => void;
	name: string;
};

const BeneficialOwnerField = ({
	isApplicant,
	person,
	onDelete,
	name,
	isShareholder,
	isMajorShareholder,
}: Props) => {
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [t, texts] = useText();

	return (
		<>
			<ClcPersonCard
				person={person}
				onDelete={isApplicant || isShareholder ? undefined : () => setIsDeleteModalOpen(true)}
				isApplicant={isApplicant}
				isShareholder={isShareholder}
			>
				<Accordion expandedDefault gap={2}>
					<Accordion.Heading>
						<Heading.H4 size="lg">
							{t(texts.newCompany.beneficialOwnership.controlHeading)}
						</Heading.H4>
					</Accordion.Heading>
					<Accordion.Content>
						<Stack gap={8}>
							<BeneficialOwnershipTypeField name={name} isMajorShareholder={isMajorShareholder} />
							<BeneficialOwnershipRangeField name={name} />
						</Stack>
					</Accordion.Content>
				</Accordion>
			</ClcPersonCard>

			<DeleteBeneficialOwnerModal
				open={isDeleteModalOpen}
				setOpen={setIsDeleteModalOpen}
				deleteBeneficialOwner={() => {
					onDelete();
				}}
				person={person}
			/>
		</>
	);
};

export default BeneficialOwnerField;
